import {
  IImageStyle,
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IFreeInputBehaviorSpecifiable, instanceOfIFreeInputBehaviorSpecifiable,
  IScriptExecuteTriggerBehaviorSpecifiable, instanceOfIScriptExecuteTriggerBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { IClaioMediaDrawableObject, instanceOfIClaioMediaDrawableObject } from "./IClaioMediaDrawableObject";

export interface IImageAreaObject extends
IClaioMediaDrawableObject,
IPrintBehaviorSpecifiable,
IFreeInputBehaviorSpecifiable,
IScriptExecuteTriggerBehaviorSpecifiable {
  imageStyle: IImageStyle;
}

export function instanceOfIImageAreaObject(instance: any): instance is IImageAreaObject {
  return instance
      && (instance.imageStyle !== undefined)
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIFreeInputBehaviorSpecifiable(instance)
      && instanceOfIScriptExecuteTriggerBehaviorSpecifiable(instance)
      && instanceOfIClaioMediaDrawableObject<IImageAreaObject>(instance, "imagearea");
}
